angular.module('impactx.osu').controller('ApprovalEntryCtrl', ['$scope', 'dataGen', '$routeParams', 'AppConfiguration', 'ixaUserActions', '$mdDialog', '$redirect', ApprovalEntryCtrl]);

function ApprovalEntryCtrl($scope, dataGen, $routeParams, AppConfiguration, ixaUserActions, $mdDialog, $redirect)
{
    this.logoUrl = AppConfiguration.get('loginPageLogoUrl');

    $mdDialog.cancel();
    ixaUserActions.openApprovalEntryDialog($routeParams.tan, $routeParams.do, $routeParams.sender, !!$routeParams.direct).finally(function () {
        $redirect.redirectTo(null, "fallbackstartpage");
    });
}